import { List, ListItem, Button, useToast } from '@chakra-ui/react';

import React, { useEffect } from 'react';
import axios from 'axios';
import FileShareAreaController from '../../../classes/FileShareAreaController';
import { File } from '../../../generated/client';
import useTownController from '../../../hooks/useTownController';

export default function FileShareDownloadList({
  fileShareController,
}: {
  fileShareController: FileShareAreaController;
}): JSX.Element {
  const [files, setFiles] = React.useState<File[]>(fileShareController.files);
  const townController = useTownController();
  const backendUrl = process.env.REACT_APP_TOWNS_SERVICE_URL;

  const toast = useToast();

  // download file from given filename on express server to user's computer
  async function handleDownload(fileName: string) {
    const res = await axios.get(backendUrl + '/download/?filename=' + fileName);
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    if (res.status === 200) {
      toast({
        title: fileName + ' downloaded!',
        description: 'Enjoy your file :)',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } else {
      toast({
        title: 'File not found!',
        description: 'Please try again.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }

  // delete given file from the server and update the list of files (trigger re-render)
  //TODO: implement this function on the server
  async function handleDeleteFile(fileName: string) {
    await axios.delete(backendUrl + '/upload/?filename=' + fileName);
    // will return the list of files from the server, set new list of files to be displayed
    fileShareController.removeFile(fileName);
    setFiles(fileShareController.files);
    townController.emitFileShareAreaUpdate(fileShareController);
  }

  useEffect(() => {
    const fileListChange = async (newFiles: File[]) => {
      setFiles(newFiles);
    };
    fileShareController.addListener('fileListChange', fileListChange);
    return () => {
      fileShareController.removeListener('fileListChange', fileListChange);
    };
  }, [fileShareController, townController, files]);

  return (
    <List spacing={3}>
      {/* <Button>Load Files</Button> */}
      {files.map(file => (
        <ListItem key={file.visibleFileName}>
          <Button
            colorScheme='teal'
            _hover={{
              background: 'white',
              color: 'teal.500',
            }}
            onClick={async () => handleDownload(file.visibleFileName)}>
            {file.visibleFileName}
          </Button>
          <Button onClick={async () => handleDeleteFile(file.visibleFileName)}> X</Button>
          {/* <IconButton
            // onClick={() => handleDownload(fileName)}
            aria-label='Download file'
            icon={<DownloadIcon />}
          /> */}
        </ListItem>
      ))}
    </List>
  );
}

/* 

//TODO: bring files into backend "File" object structure

FileShareDownloadList.tsx


bring in controller prop


-add listeners for events of fileuploaded
when fileuploaded, re-renders list in useeffect on frontend

...
return {

    listitem contains name of file and then download button to the right (clickable)
    
    map(files -> render something like <ListItem>);
    <FileUpload />
}


*/
